import {priority} from '@priority-software/priority-proto-api/lib';
import {showFormClientSideMessage} from '../../Form/actions/messages';
import {ActionTypes} from '../reducer/actions';
import {TVoidFunction} from '../types';
import {IUseEmailCommonHandlersArg} from './types';
import {texts} from '../texts';

export const useEmailCommonHandlers = ({dispatch}: IUseEmailCommonHandlersArg) => {
    const onBack = (closeCb?: TVoidFunction) => {
        showFormClientSideMessage('', priority.netitems.shared.Message.Type.Warning, {
            title: texts.go_back_dialog_title,
            content: texts.go_back_dialog_content,
            confirmButtonText: texts.go_back_dialog_primary_btn,
            cancleButtonText: texts.go_back_dialog_secondary_btn,
            onConfirm: () => {
                closeCb();
                dispatch({type: ActionTypes.CLOSE_EMAILEDITOR});
            }
        });
    };

    return {onBack} as const;
};
